import { View } from "react-native";
import React, { useEffect, useState } from "react";
import { BillingInterval, PlanPackageDetails } from "features/types";
import { useAppSelector } from "hooks/useAppSelector";
import { IndexPath, Select, SelectItem, Text } from "@ui-kitten/components";
import RenderHtmlComponent from "components/RenderHtml";
import StripePaymentForm, {
  StripeTokenError,
  StripeTokenResponse,
} from "components/StripePaymentForm/StripePaymentForm";
import { useAppDispatch } from "hooks/useAppDispatch";
import { setSelectedBillingInterval } from "features/slices/buyFlowSlice";
import BuyFlowPaymentDetailCard from "components/BuyFlowPaymentDetailCard";
import i18n from "plugins/localization";
import OrderSummary from "components/OrderSummary";
import Spacer from "components/Spacer";
import { billingIntervalDisplayValue } from "utils/planPackageUtils";

interface StepThreeProps {
  selectedPlanPackage: PlanPackageDetails;
  selectedBillingInterval: BillingInterval;
  onTokenReceived: (
    error: StripeTokenError | undefined,
    response: StripeTokenResponse | undefined
  ) => void;
}
const StepThree: React.FC<StepThreeProps> = ({
  selectedBillingInterval,
  selectedPlanPackage,
  onTokenReceived,
}) => {
  const { signupCharge } = useAppSelector((state) => state.buyFlow);
  const dispatch = useAppDispatch();

  const availableBillingIntervals = selectedPlanPackage.billingIntervals;
  const displayValue = billingIntervalDisplayValue(selectedBillingInterval);

  const selectedIndex = availableBillingIntervals.findIndex(
    (interval) => interval === selectedBillingInterval
  );

  return (
    <View>
      <View>
        {availableBillingIntervals.length > 1 && (
          <View style={{ marginBottom: 25 }}>
            <Text category="h6" style={{ marginBottom: 10 }}>
              {i18n.t("screens.Register.paymentInterval")}
            </Text>
            <Select
              testID="register-billing-interval-selector"
              value={displayValue}
              selectedIndex={new IndexPath(selectedIndex)}
              onSelect={(index) => {
                dispatch(
                  setSelectedBillingInterval(
                    availableBillingIntervals[(index as IndexPath).row]
                  )
                );
              }}
            >
              {availableBillingIntervals.map((interval) => (
                <SelectItem
                  testID="register-billing-interval-item"
                  key={interval}
                  title={billingIntervalDisplayValue(interval)}
                ></SelectItem>
              ))}
            </Select>
          </View>
        )}
      </View>

      <View style={{ marginBottom: 50 }}>
        {signupCharge !== null && (
          <>
            <View style={{ marginVertical: 10 }}>
              <RenderHtmlComponent
                source={selectedPlanPackage?.description || ""}
              />
            </View>
            <BuyFlowPaymentDetailCard
              planPackage={selectedPlanPackage}
              signupCharge={signupCharge}
            ></BuyFlowPaymentDetailCard>
          </>
        )}
      </View>
      <Spacer margin={15}>
        {signupCharge && (
          <OrderSummary
            signupCharge={signupCharge}
            planPackage={selectedPlanPackage}
          />
        )}
      </Spacer>
      <Text category="h6" style={{ marginBottom: 15 }}>
        {i18n.t("screens.Register.creditCardInformation")}
      </Text>
      <StripePaymentForm onTokenReceived={onTokenReceived}></StripePaymentForm>
    </View>
  );
};

export default StepThree;
